// Dispatcher Dashboard — Premium Professional Design
// Matches AdminDashboard quality exactly
// Emerald/Teal theme, real data
// ============================================

import React, { useState, useEffect, useCallback } from 'react';
import DispatcherLayout from '../../components/dispatcher/DispatcherLayout';
import dispatcherService from '../../services/dispatcherService';
import socketService from '../../services/socket';
import { Link } from 'react-router-dom';
// ── Premium SVG Icons ──────────────────────────
const icons = {
    drivers: (
        <svg viewBox="0 0 24 24" fill="none" className="w-6 h-6">
            <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    routes: (
        <svg viewBox="0 0 24 24" fill="none" className="w-6 h-6">
            <path d="M12 22s-8-4.5-8-11.8A8 8 0 0112 2a8 8 0 018 8.2c0 7.3-8 11.8-8 11.8z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="1.5" />
        </svg>
    ),
    vehicles: (
        <svg viewBox="0 0 24 24" fill="none" className="w-6 h-6">
            <path d="M5 17h14M5 17a2 2 0 01-2-2V7a2 2 0 012-2h2l2-2h6l2 2h2a2 2 0 012 2v8a2 2 0 01-2 2M5 17l-1 2h2m12-2l1 2h-2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="7.5" cy="14.5" r="1.5" stroke="currentColor" strokeWidth="1.5" />
            <circle cx="16.5" cy="14.5" r="1.5" stroke="currentColor" strokeWidth="1.5" />
            <path d="M5 10h14" stroke="currentColor" strokeWidth="1.5" />
        </svg>
    ),
    jobs: (
        <svg viewBox="0 0 24 24" fill="none" className="w-6 h-6">
            <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <rect x="9" y="3" width="6" height="4" rx="1" stroke="currentColor" strokeWidth="1.5" />
            <path d="M9 14l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    liveMap: (
        <svg viewBox="0 0 24 24" fill="none" className="w-6 h-6">
            <path d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    trackingLink: (
        <svg viewBox="0 0 24 24" fill="none" className="w-6 h-6">
            <path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    reassign: (
        <svg viewBox="0 0 24 24" fill="none" className="w-6 h-6">
            <path d="M16 3h5v5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M21 3l-7 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8 21H3v-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3 21l7-7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    alert: (
        <svg viewBox="0 0 24 24" fill="none" className="w-6 h-6">
            <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <line x1="12" y1="9" x2="12" y2="13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            <line x1="12" y1="17" x2="12.01" y2="17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    ),
    arrowUp: (
        <svg viewBox="0 0 12 12" fill="none" className="w-3 h-3">
            <path d="M6 9V3M3.5 5.5L6 3l2.5 2.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    warning: (
        <svg viewBox="0 0 12 12" fill="none" className="w-3 h-3">
            <path d="M6 4v2.5M6 8.5h.005" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M5.134 1.806L.933 9.073C.484 9.857 1.058 10.833 1.96 10.833h8.08c.903 0 1.477-.976 1.028-1.76L6.866 1.806a1 1 0 00-1.732 0z" stroke="currentColor" strokeWidth="1" />
        </svg>
    ),
};

const DispatcherDashboard = () => {
    const [stats, setStats] = useState(null);
    const [drivers, setDrivers] = useState([]);
    // const [routes, setRoutes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const [statsRes, driversRes] = await Promise.all([
                dispatcherService.getStats(),
                dispatcherService.getDrivers(),
            ]);
            if (statsRes.data.success) setStats(statsRes.data.data.stats);
            if (driversRes.data.success) setDrivers(driversRes.data.data.drivers?.slice(0, 5) || []);
        } catch (err) {
            console.error('Dashboard fetch error:', err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData();
        const interval = setInterval(fetchData, 30000);
        
        const handleRouteUpdate = () => {
            fetchData();
        };

        socketService.on('route:updated', handleRouteUpdate);
        socketService.on('route:children:updated', handleRouteUpdate);
        socketService.on('child:updated', handleRouteUpdate);

        return () => {
            clearInterval(interval);
            socketService.off('route:updated', handleRouteUpdate);
            socketService.off('route:children:updated', handleRouteUpdate);
            socketService.off('child:updated', handleRouteUpdate);
        };
    }, [fetchData]);

    const statCards = [
        {
            label: 'Active Drivers',
            value: stats?.activeDrivers || '0',
            change: `${stats?.totalDrivers || 0} total fleet`,
            trend: 'up',
            icon: icons.drivers,
            gradient: 'from-emerald-500 to-teal-600',
            shadowColor: 'shadow-emerald-500/20',
        },
        {
            label: 'Routes Today',
            value: stats?.totalRoutes || '0',
            change: 'School & private',
            trend: 'up',
            icon: icons.routes,
            gradient: 'from-sky-500 to-blue-600',
            shadowColor: 'shadow-sky-500/20',
        },
        {
            label: 'Fleet Vehicles',
            value: stats?.totalVehicles || '0',
            change: 'All operational',
            trend: 'up',
            icon: icons.vehicles,
            gradient: 'from-amber-500 to-orange-600',
            shadowColor: 'shadow-amber-500/20',
        },
        {
            label: 'Children on Route',
            value: stats?.totalChildren || '0',
            change: `${stats?.totalSchools || 0} schools`,
            trend: 'up',
            icon: icons.jobs,
            gradient: 'from-rose-500 to-pink-600',
            shadowColor: 'shadow-rose-500/20',
        },
    ];

    const driverAvatarGradients = [
        'from-emerald-400 to-teal-500',
        'from-sky-400 to-blue-500',
        'from-amber-400 to-orange-500',
        'from-rose-400 to-pink-500',
        'from-violet-400 to-purple-500',
    ];

    /* const statusStyles = {
        'Completed': { bg: 'bg-emerald-50', text: 'text-emerald-700', dot: 'bg-emerald-500' },
        'In Progress': { bg: 'bg-blue-50', text: 'text-blue-700', dot: 'bg-blue-500' },
        'Active': { bg: 'bg-emerald-50', text: 'text-emerald-700', dot: 'bg-emerald-500' },
        'Assigned': { bg: 'bg-amber-50', text: 'text-amber-700', dot: 'bg-amber-500' },
        'Pending': { bg: 'bg-slate-100', text: 'text-slate-600', dot: 'bg-slate-400' },
    }; */

    return (
        <DispatcherLayout 
            title="Dashboard" 
            subtitle="Live fleet operations overview"
            searchTerm={searchTerm}
            onSearchChange={setSearchTerm}
        >
            {/* Stats Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6 mb-8 relative z-10">
                {statCards.map((stat, i) => (
                    <div key={i} className="bg-white/60 dark:bg-slate-900/40 backdrop-blur-3xl rounded-[2.5rem] p-6 border border-white/60 dark:border-white/10 shadow-sm dark:shadow-2xl hover:shadow-xl hover:shadow-slate-200/40 dark:hover:shadow-black/50 transition-all duration-500 group cursor-default relative overflow-hidden">
                        {/* Background gradient glow */}
                        <div className={`absolute -top-12 -right-12 w-32 h-32 bg-gradient-to-br ${stat.gradient} opacity-[0.06] rounded-full blur-2xl group-hover:opacity-[0.12] transition-opacity duration-500`} />

                        <div className="flex items-start justify-between mb-5 relative">
                            <div className={`w-12 h-12 rounded-2xl bg-gradient-to-br ${stat.gradient} flex items-center justify-center text-white shadow-lg ${stat.shadowColor} group-hover:scale-110 group-hover:shadow-xl transition-all duration-300`}>
                                {stat.icon}
                            </div>
                            <div className={`flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] font-bold tracking-wide ${stat.trend === 'up'
                                ? 'bg-emerald-50 text-emerald-600 border border-emerald-100'
                                : 'bg-rose-50 text-rose-600 border border-rose-100'
                                }`}>
                                {stat.trend === 'up' ? icons.arrowUp : icons.warning}
                                {stat.change}
                            </div>
                        </div>
                        <p className="text-3xl font-black text-slate-900 dark:text-white tracking-tight relative">
                            {loading ? '...' : stat.value}
                        </p>
                        <p className="text-sm text-slate-500 dark:text-slate-400 mt-1 font-bold tracking-wide relative">{stat.label}</p>
                    </div>
                ))}
            </div>
            {/* Driver Status Layout */}
            <div className="mb-8 relative z-10">
                {/* Driver Status Panel */}
                <div className="bg-white/60 dark:bg-slate-900/40 backdrop-blur-3xl rounded-[2.5rem] border border-white/60 dark:border-white/10 overflow-hidden shadow-sm dark:shadow-2xl">
                    <div className="p-6 border-b border-slate-200/50 dark:border-white/5">
                        <h3 className="text-base font-black text-slate-900 dark:text-white tracking-tight">Driver Status</h3>
                        <p className="text-[11px] font-bold tracking-widest uppercase text-slate-500 dark:text-slate-400 mt-1">Real-time fleet overview</p>
                    </div>
                    <div className="p-4 space-y-2">
                        {loading ? (
                            [...Array(4)].map((_, i) => (
                                <div key={i} className="animate-pulse flex items-center gap-3 p-3">
                                    <div className="w-10 h-10 bg-slate-100 rounded-xl" />
                                    <div className="flex-1 space-y-2">
                                        <div className="h-3 bg-slate-100 rounded w-24" />
                                        <div className="h-2 bg-slate-50 rounded w-16" />
                                    </div>
                                </div>
                            ))
                        ) : drivers.filter(d => d.name.toLowerCase().includes(searchTerm.toLowerCase())).length === 0 ? (
                            <div className="py-8 text-center text-sm text-slate-400 italic">No matching drivers</div>
                        ) : (
                            drivers.filter(d => d.name.toLowerCase().includes(searchTerm.toLowerCase())).map((d, i) => (
                                <div key={d._id} className="flex items-center gap-4 p-3 rounded-2xl hover:bg-slate-100/50 dark:hover:bg-slate-800/50 transition-all duration-300 cursor-default group">
                                    <div className="relative">
                                        <div className={`w-11 h-11 rounded-[14px] bg-gradient-to-br ${driverAvatarGradients[i % 5]} flex items-center justify-center text-xs font-black text-white shadow-lg group-hover:scale-105 transition-all`}>
                                            {d.name?.split(' ').map(n => n[0]).join('') || '?'}
                                        </div>
                                        <div className={`absolute -bottom-1 -right-1 w-4 h-4 rounded-full border-2 border-white dark:border-slate-800 shadow-sm ${d.isBlocked ? 'bg-rose-500' : d.isVerified ? 'bg-emerald-500' : 'bg-slate-400'
                                            }`} />
                                    </div>
                                    <div className="flex-1 min-w-0">
                                        <p className="text-sm font-bold text-slate-900 dark:text-white truncate">{d.name}</p>
                                        <p className="text-[10px] font-bold tracking-wider uppercase text-slate-500 dark:text-slate-400">{d.phone || d.email}</p>
                                    </div>
                                    <div className="text-right">
                                        <p className="text-[11px] font-semibold text-slate-700">
                                            {d.isBlocked ? 'Inactive' : d.isVerified ? 'Active' : 'Inactive'}
                                        </p>
                                        <p className={`text-[10px] font-bold flex items-center justify-end gap-1 ${d.isBlocked ? 'text-rose-600' : d.isVerified ? 'text-emerald-600' : 'text-amber-600'}`}>
                                            {d.isBlocked ? (
                                                <><svg className="w-3 h-3 text-rose-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg> Inactive</>
                                            ) : d.isVerified ? (
                                                <><svg className="w-3 h-3 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" /></svg> Compliant</>
                                            ) : (
                                                <><svg className="w-3 h-3 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg> Unverified</>
                                            )}
                                        </p>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                    <div className="p-4 border-t border-slate-200/50 dark:border-white/5">
                        <Link to="/dispatcher/drivers" className="block w-full py-3 rounded-[1.25rem] text-xs uppercase tracking-widest font-black text-emerald-600 dark:text-emerald-400 bg-emerald-50/50 dark:bg-emerald-500/5 hover:bg-emerald-100 dark:hover:bg-emerald-500/10 border border-emerald-100 dark:border-emerald-500/10 transition-all duration-300 text-center hover:scale-[1.02]">
                            View All Drivers
                        </Link>
                    </div>
                </div>
            </div>

            {/* Quick Actions */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 relative z-10">
                {[
                    { title: 'Open Live Map', desc: 'Track all active drivers', icon: icons.liveMap, gradient: 'from-emerald-500 to-teal-600', shadow: 'shadow-emerald-500/30', href: '/dispatcher/live-map' },
                    { title: 'Reassign Job', desc: 'Swap driver assignment', icon: icons.reassign, gradient: 'from-sky-500 to-blue-600', shadow: 'shadow-sky-500/30', href: '/dispatcher/reassign' },
                    { title: 'Share Tracking', desc: 'Generate parent link', icon: icons.trackingLink, gradient: 'from-amber-500 to-orange-600', shadow: 'shadow-amber-500/30', href: '/dispatcher/tracking-links' },
                    { title: 'View Alerts', desc: 'Compliance & delays', icon: icons.alert, gradient: 'from-rose-500 to-pink-600', shadow: 'shadow-rose-500/30', href: '/dispatcher/alerts' },
                ].map((action, i) => (
                    <Link key={i} to={action.href} className="flex items-center gap-4 p-5 rounded-[2rem] bg-white/60 dark:bg-slate-900/40 backdrop-blur-3xl border border-white/60 dark:border-white/10 hover:shadow-xl hover:shadow-slate-200/50 dark:hover:shadow-black/60 transition-all duration-300 text-left group hover:scale-[1.03] no-underline">
                        <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${action.gradient} flex items-center justify-center text-white shadow-lg ${action.shadow} group-hover:scale-110 group-hover:rotate-3 transition-transform duration-300`}>
                            {action.icon}
                        </div>
                        <div>
                            <p className="text-sm font-black text-slate-900 dark:text-white group-hover:text-emerald-600 dark:group-hover:text-emerald-400 transition-colors tracking-tight">{action.title}</p>
                            <p className="text-[10px] font-bold tracking-widest uppercase text-slate-500 dark:text-slate-400 mt-1">{action.desc}</p>
                        </div>
                    </Link>
                ))}
            </div>
        </DispatcherLayout>
    );
};

export default DispatcherDashboard;
